import { PendingOrder, PropertyInformation } from '../types';

export function initialPropertyInformation(pendingOrder: PendingOrder | null): PropertyInformation {
    const contact = pendingOrder ? pendingOrder.contact : {};
    const address = pendingOrder ? pendingOrder.address : {};

    return {
        owner: {
            ownerFirstName: contact.ownerFirstName || '',
            ownerLastName: contact.ownerLastName || '',
            ownerEmailAddress: contact.ownerEmailAddress || '',
            ownerPrimaryPhoneNumber: contact.ownerPrimaryPhoneNumber || ''
        },
        address: {
            addressLine1: address.addressLine1 || '',
            addressPostalNumber: address.addressPostalNumber || '',
            addressCity: address.addressCity || '',
            addressDistrict: address.addressDistrict || '',
            objectType: address.objectType || null,
            addressPointLocation: address.addressPointLocation || null
        },
        notes: '',
        extraDeliveryRecipients: ''
    };
}

function isFilledIn(text: string): boolean {
    return text.trim().length > 0;
}

export function isPropertyInformationComplete({ address }: PropertyInformation): boolean {
    return (
        isFilledIn(address.addressLine1) &&
        isFilledIn(address.addressPostalNumber) &&
        isFilledIn(address.addressCity) &&
        address.objectType !== null
    );
}
